(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('declined', {
            parent: 'entity',
            url: '/declined?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.declined.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/declined/declineds.html',
                    controller: 'DeclinedController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('declined');
                    $translatePartialLoader.addPart('enumDeclined');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('declined-detail', {
            parent: 'entity',
            url: '/declined/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.declined.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/declined/declined-detail.html',
                    controller: 'DeclinedDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('declined');
                    $translatePartialLoader.addPart('enumDeclined');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Declined', function($stateParams, Declined) {
                    return Declined.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('declined.new', {
            parent: 'declined',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/declined/declined-dialog.html',
                    controller: 'DeclinedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                reason: null,
                                other: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('declined', null, { reload: true });
                }, function() {
                    $state.go('declined');
                });
            }]
        })
        .state('declined.edit', {
            parent: 'declined',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/declined/declined-dialog.html',
                    controller: 'DeclinedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Declined', function(Declined) {
                            return Declined.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('declined', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('declined.delete', {
            parent: 'declined',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/declined/declined-delete-dialog.html',
                    controller: 'DeclinedDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Declined', function(Declined) {
                            return Declined.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('declined', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
